__turbopack_context__.v({
  "btnWrapper": "BasicSection-module-scss-module__vLutVq__btnWrapper",
  "btnWrapperInner": "BasicSection-module-scss-module__vLutVq__btnWrapperInner",
  "content": "BasicSection-module-scss-module__vLutVq__content",
  "contentInner": "BasicSection-module-scss-module__vLutVq__contentInner",
  "contentWrapper": "BasicSection-module-scss-module__vLutVq__contentWrapper",
  "contentWrapperOneCol": "BasicSection-module-scss-module__vLutVq__contentWrapperOneCol",
  "contentWrapperReversed": "BasicSection-module-scss-module__vLutVq__contentWrapperReversed",
  "imgWrapper": "BasicSection-module-scss-module__vLutVq__imgWrapper",
  "imgWrapperVertical": "BasicSection-module-scss-module__vLutVq__imgWrapperVertical",
});
